import { createFetchRetry } from '@rsos/capstone';
import { store } from './store';

export default createFetchRetry(store);
